import { Star, ExternalLink } from "lucide-react";
import { SectionHeader } from "@/components/SectionHeader";
import { Reveal, RevealStagger } from "@/components/Reveal";

/* Avis Google réels — fiche GBP HRC Rénovation (4,9/5).
   Mise à jour manuelle : recopier ici les nouveaux avis quand ils arrivent. */
const GBP_URL = "https://maps.google.com/?cid=7509332169605996466";

const avis = [
  {
    text: "Artisans très compétents, dynamiques, sympathiques et respectueux de l'environnement. Ils n'ont pas hésité à faire plusieurs démonstrations gratuites sur plusieurs matériaux avec des résultats étonnants. Notre façade sud pleine de coulées noires et rouges est à nouveau comme neuve. Nos tuiles noircies avec beaucoup de mousse verte ont retrouvé leur belle couleur d'origine. Prix très raisonnable vu la qualité du travail.",
    name: "Marie-Annick Lavauzelle",
    rating: 5,
  },
  {
    text: "Très bonne entreprise, très arrangeante, très sérieuse et efficace. Je la conseille pour prendre soin de votre toiture comme de votre terrasse, façade, chemin en dalle, carrelage… Au niveau tarif, très raisonnable. Je les ai fait venir sur le secteur de la Dordogne.",
    name: "Christopher Raymond",
    rating: 5,
  },
  {
    text: "Artisan sympathique et arrangeant, j'ai fait appel à lui pour le traitement de ma toiture, travail propre et efficace, je recommande.",
    name: "Xehanful",
    rating: 5,
  },
  {
    text: "Travail sérieux, efficace, mené proprement. Prix raisonnable.",
    name: "Eric Heyvaert",
    rating: 5,
  },
  {
    text: "Travail sérieux et bien fait.",
    name: "Roger Winkler",
    rating: 4,
  },
];

const GoogleG = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
    <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
    <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
    <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
  </svg>
);

export const Testimonials = () => (
  <section className="pt-16 lg:pt-28 pb-16 bg-surface-canvas" data-testid="testimonials-section">
    <div className="max-w-site mx-auto px-5 lg:px-6">
      <SectionHeader
        label="Avis clients"
        title="Ce que disent vos voisins."
        subtitle="Note de 4,9/5 sur Google. Des retours de clients accompagnés en Dordogne et alentours."
      />

      <div className="relative">
        <RevealStagger className="flex gap-6 overflow-x-auto pb-4 snap-x snap-mandatory">
          {avis.map((a) => (
            <article key={a.name} className="bg-white rounded-2xl p-8 shadow-subtle border border-line min-w-[85%] sm:min-w-[340px] lg:min-w-[368px] lg:max-w-[368px] snap-start flex flex-col">
              <div className="flex gap-1 mb-5" aria-label={`${a.rating} étoiles sur 5`}>
                {[...Array(5)].map((_, i) => (
                  <Star key={i} size={17} fill={i < a.rating ? "#F59E0B" : "#E4E9F0"} className={i < a.rating ? "text-warm" : "text-line"} aria-hidden="true" />
                ))}
              </div>
              <p className="text-[15px] text-ink flex-1">« {a.text} »</p>
              <div className="h-px bg-line my-5" />
              <div className="flex items-end justify-between">
                <div>
                  <p className="font-semibold text-[15px] text-brand-deep">{a.name}</p>
                  <p className="text-sm text-ink-secondary">Avis Google</p>
                </div>
                <GoogleG />
              </div>
            </article>
          ))}
        </RevealStagger>
        {/* Indice visuel qu'il reste des avis à droite du carrousel (dégradé de fondu) */}
        <div
          className="hidden sm:block pointer-events-none absolute top-0 right-0 bottom-4 w-16"
          style={{ background: "linear-gradient(90deg, rgba(250,251,252,0) 0%, var(--surface-canvas) 100%)" }}
          aria-hidden="true"
        />
      </div>

      <Reveal className="text-center mt-10">
        <a href={GBP_URL} target="_blank" rel="noopener noreferrer" className="btn-base btn-outline-deep" data-testid="google-reviews-btn">
          Voir tous nos avis sur Google
          <ExternalLink size={16} aria-hidden="true" />
        </a>
      </Reveal>
    </div>
  </section>
);
